/**
* @Author: zachalam
* @Date:   2017-03-14T15:57:03-07:00
* @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-03-29T14:54:22-07:00
*/



import React, { Component } from 'react';
import ReactModal from 'react-modal';
import Button from '../blocks/Button';
import ButtonSet from '../blocks/ButtonSet';
import { type, borders, spacing } from '../../style'
import { css, StyleSheet } from 'aphrodite/no-important';

const style = StyleSheet.create({
  modalContent: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '3px',
    backgroundColor: '#fff',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '520px',
    transform: 'scale(1)',
    ...borders.DEFAULT,
    ...spacing.PADDING_SM,
    opacity: '1',
    transition: 'opacity 200ms ease,transform 150ms ease'
  },

  modalTable: {
    display: 'table',
    tableLayout: 'fixed',
    height: '100%',
    width: '100%'
  },

  modalCell: {
    display: 'table-cell',
    height: '100%',
    width: '100%',
    verticalAlign: 'middle'
  },

  modalContainer: {
    position: 'fixed',
    zIndex: '2000',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    overflowY: 'auto',
    transform: 'translate3d(0, 0, 0)',
    backgroundColor: 'rgba(0,0,0,0.75)',
  },

  close: {
    appearance: 'none',
    border: 'none',
    background: 'none',
    position: 'absolute',
    top: '0',
    right: '0',
    width: '48px',
    height: '48px'
  }
})

class Modal extends Component {

  constructor(props) {
    super(props);
    //console.log("open status", props.openStatus);
    this.state = {
      isOpen: props.openStatus
    }

    this.renderYesCallBack = this.renderYesCallBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalCallBack = this.closeModalCallBack.bind(this);
    this.openModal = this.openModal.bind(this);
    this.renderButtonOrLink = this.renderButtonOrLink.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // apply new open status to the Modal state.
    this.setState({isOpen: nextProps.openStatus})
  }

  closeModal(e) {
    // e.preventDefault();
    this.setState({isOpen: false});
  }
  closeModalCallBack(e) {
    // close modal and run callback.
    this.closeModal(e);
    this.props.yesCallback();
  }

  openModal(e) {
    e.preventDefault();
    this.setState({isOpen: true});
  }

  renderYesCallBack(showButtons, yesBtnMsg, noBtnMsg) {
      // shows yes/no buttons if a "yes" callback is present.
      if(showButtons) {
        yesBtnMsg = yesBtnMsg || 'Yes';
        noBtnMsg = noBtnMsg || 'No';
        return (
          <ButtonSet>
            <Button variant="primary" onClick={this.closeModalCallBack}>{yesBtnMsg}</Button>
            <Button variant="simple" onClick={this.closeModal}>{noBtnMsg}</Button>
          </ButtonSet>
        );
      }
      else {
        return (<div />);
      }

  }

  renderButtonOrLink(linkText) {
    if(linkText) {
      // render link
      return (<a href="" onClick={this.openModal}>{this.props.linkText}</a>);
    } else {
      // render button text
      if(this.props.buttonText)
      return (<Button variant="simple" onClick={this.openModal}>{this.props.buttonText}</Button>);
      else {
        return (<span />);
      }
    }
  }

  renderCloseButton() {
    if(!this.props.disableClose) {
      return( 
        <button onClick={this.closeModal} className={css(style.close)}>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{display: 'block', fill: 'rgb(118, 118, 118)', height: '16px', width: '16px'}}><path fillRule="evenodd" d="M23.25 24a.744.744 0 0 1-.53-.22L12 13.062 1.28 23.782a.75.75 0 0 1-1.06-1.06L10.94 12 .22 1.28A.75.75 0 1 1 1.28.22L12 10.94 22.72.22a.749.749 0 1 1 1.06 1.06L13.062 12l10.72 10.72a.749.749 0 0 1-.53 1.28"></path></svg>
        </button>
      )
    }
  }

  render() {

    return (
      <div className="modalCell">
        {this.renderButtonOrLink(this.props.linkText)}
        <ReactModal
          className={css(style.modalTable)}
          overlayClassName={css(style.modalContainer)}
          isOpen={this.state.isOpen}
          contentLabel="Modal"
          shouldCloseOnOverlayClick={true}
          >
            <div className={css(style.modalCell)}>
              <div className={css(style.modalContent)}>
                {this.renderCloseButton()}
                {this.props.title}
                {this.props.children}
                {this.renderYesCallBack(Boolean(this.props.yesCallback!=undefined), this.props.yesBtn, this.props.noBtn)}
              </div>
            </div>
        </ReactModal>
      </div>

    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal.jsx